<script>
    import { fly } from 'svelte/transition';

    export let delay;
    export let translateY = 0;

</script>

<svg in:fly="{{delay: delay, duration: 600, y: -100}}" out:fly="{{ duration: 600, y: -100}}" viewBox="0 0 20 20" preserveAspectRatio="xMinYMin meet" style="transform: translate(-1.35vw, {translateY}vw);">
    <g>
        <circle r="50%"
            cx="50%" cy="50%"
        />
      </g>
</svg>


<style>
    circle {
        fill: var(--color-primary);
        /* cursor: move; */
    }
    svg {
        overflow: visible;
        position: absolute;
        max-width: 2.5vw;
        max-height: 2.5vw;
        z-index: 2;
    }
</style>